import {observer} from "mobx-react";
import * as React from "react";
import {action, observable} from "mobx";
import {CommentDataInterface} from "../../../data/FullPostModalData";

import {NavAvatar} from "../../nav/NavAvatar";

import './CommentAdd.pcss';
import {handleSpacePressed, resizeImage} from "../../../utils";
import {User} from "../../../data/entities/User";
import {Alert} from "../../../data/Alert";
import { MentionsInput, Mention } from 'react-mentions'
import {IMentionUser} from "shared/IMentionUser";
import {UIState} from "data/UIState";
import UserDataSource from "data/UserDataSource";
import * as theme from 'theme.js';

interface Props {
  addComment:(commentData:CommentDataInterface)=>Promise<void>;
  user:User;
  possibleUsersToMention:IMentionUser[];
}

const IMAGE_DISPLAY_WIDTH = 654;


@observer
class CommentAdd extends React.Component<Props> {
  @observable active = false;
  @observable submittingComment = false;
  @observable resizingImage = false;
  @observable comment = ""; //test @[ATrackOne](5ebeea46eee35b4325a36a81) this";
  @observable imageDataURI:any;
  imageInputRef;
  textareaRef;
  @observable mentionedUsers:IMentionUser[] = [];
  //@observable users:IMentionUser[] = [];

  constructor(props:Props) {
    super(props);

    this.imageInputRef = React.createRef();
    this.textareaRef = React.createRef();

    // if(UIState.feedData && UIState.feedData.solution) {
    //   UserDataSource.loadMentionUsersForSolution(UIState.feedData.solution._id).then(this.handleLoadUsersSuccess).catch(()=>{
    //     console.log("Failed to load mention users.");
    //   });
    // } else {
    //   console.log("No solution available, impossible to mention users.");
    // }


  }

  // @action handleLoadUsersSuccess = (users:IMentionUser[]) => {
  //   for(let i=0; i<users.length; i++){
  //     users[i].display = " @"+users[i].display+" ";
  //   }
  //   this.users = users;
  // }

  @action handleSubmitComment = () => {

    if(this.submittingComment) {
      return;
    }

    this.submittingComment = true;
    if(this.comment.trim().length<2) {
      Alert.alert('Text is required to post a comment.');
      this.submittingComment = false;
      return;
    }

    const commentData = {
      comment:this.comment.trim(),
      photo:this.imageDataURI?this.imageDataURI:undefined,
    }

    this.props.addComment(commentData)
    .then(action(() => {
      UIState.setAriaLiveAnnouncement("Comment posted.");
      this.submittingComment = false;
      this.handleCancel();
    }))
    .catch(action((err) => {
      console.log(err);
      Alert.alert('We\'re sorry! It looks like you might not be connected to the Internet. Please make sure you have a good Internet connection and try to post again. If that does not work, please log in again.');
      this.submittingComment = false;
    }));

  }

  renderPreview = (input) => {
    if(this.imageInputRef.current) {
      this.active = true;
      if (this.imageInputRef.current.files && this.imageInputRef.current.files[0]) {
        if(!this.resizingImage) {
          this.resizingImage = true;
          resizeImage(this.imageInputRef.current.files[0], IMAGE_DISPLAY_WIDTH)
              .then((image) => {
                this.imageDataURI = image;
                this.resizingImage = false;
              })
              .catch((err) => {
                console.log(err);
                this.resizingImage = false;
                Alert.alert('The image you selected did not work. Please try again.');
              });
        }
      }
    }
  }

  @action handleCancel = () => {
    this.comment = '';
    this.imageDataURI = null;
    this.active = false;
    // this.textareaRef.current.innerHTML = '';
  }

  handleImageIconClick = () => {
    if(!this.submittingComment) {
      this.imageInputRef.current.click();
    }
  }

  @action handleClearImage = () => {
    this.imageDataURI = null;
    this.imageInputRef.current.value = null;
  }

  render(){
    return (
        <div className="add-comment">

          <h3 className="level3 shadow ac-label">Add a comment</h3>

          <div className={`ac-content${this.active?' active'+(this.imageDataURI ? '' : ' no-image'):''}`}>


            <MentionsInput
              placeholder={"enter a comment..."}
              className={"mentions-input"}
              style={this.active?styleMentionsInputActive:styleMentionsInput}
              value={this.comment}
              onChange={action((event, newValue, newPlainValue, mentions)=>{
                this.comment = event.target.value;
                this.mentionedUsers = mentions;
              })}
              onFocus={()=>{
                this.active = true;
                if(!this.imageDataURI) {
                  setTimeout(() => {
                    const elements = document.getElementsByClassName("body scroll");
                    if (elements.length > 0) {
                      elements[0].scrollTo({left: 0, top: elements[0].scrollHeight, behavior: "smooth"});
                    }
                  }, 1);
                }
              }}
            >
              <Mention
                style={styleMention}
                trigger="@"
                data={this.props.possibleUsersToMention}
                renderSuggestion={(suggestion, search, highlightedDisplay) => (
                  <div className="user">{highlightedDisplay}</div>
                )}
              />
            </MentionsInput>

            <input tabIndex={-1} aria-hidden ref={this.imageInputRef} type="file" id="fileUpload" style={{opacity:0, height:0, width:0, position:'absolute', display:'none'}} onChange={this.renderPreview} />

            {!this.imageDataURI ?
                <>
                {this.resizingImage ?
                    <span className="material-icons icon-spin resizing">sync</span>
                    :
                    <a
                      tabIndex={0}
                      aria-label={"Add image to post"}
                      role={"button"} className={"ac-image-btn"} href={"#"}
                      onKeyDown={(e)=>{ handleSpacePressed(e, this.handleImageIconClick);}}
                      onClick={this.handleImageIconClick}><span aria-hidden className="material-icons">photo_library</span></a>
                }
                </>

                :
                <div className={"ac-image"}>
                  <img alt={"Your uploaded image"} src={this.imageDataURI} />
                  <a tabIndex={0}
                     role={"button"}
                     aria-label={"remove image from post"}
                     className={"ac-image-btn-clear"} href={"#"}
                     onKeyDown={(e)=>{ handleSpacePressed(e, this.handleClearImage);}}
                     onClick={this.handleClearImage}
                  ><span aria-hidden className="material-icons">close</span></a>
                </div>
            }
            {!this.active ?
              <div className={`ac-content-top`}>
                <NavAvatar alt={""} user={this.props.user} variant={'small'} />
              </div>
              :
              <div className={"ac-content-top"}>
                <NavAvatar alt={""} user={this.props.user} variant={'small'} />
                <div aria-hidden className={"ac-username"}>{this.props.user.nameOrNickname}</div>
                <div className={"ac-actions"}>
                  <a tabIndex={0}
                     role={"button"}
                     className="ac-btn cancel"
                     onClick={this.handleCancel}
                     onKeyDown={(e)=>{ handleSpacePressed(e, this.handleCancel);}}
                     aria-label={"Cancel comment"}><span aria-hidden>Cancel</span></a>
                  <a tabIndex={0}
                     role={"button"}
                     className="ac-btn post three-band-focus"
                     onClick={this.handleSubmitComment}
                     onKeyDown={(e)=>{ handleSpacePressed(e, this.handleSubmitComment);}}
                     aria-label={"Post comment"}><span aria-hidden>Post</span></a>
                </div>
              </div>
            }
          </div>
        </div>
    );
  }

}

export default CommentAdd



const styleMentionsInput = {
  control: {
    backgroundColor: '#fff',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '32px',
    color: theme.CharcoalAAA,
    borderColor: 'transparent',
  },

  '&multiLine': {
    position: 'absolute',
    top: '12px',
    left: '50px',
    lineHeight: '32px',
    right: '56px',
    control: {
      //fontFamily: 'monospace',
      minHeight: 'unset',
    },
    highlighter: {
      //padding: 9,
      //border: '1px solid transparent',
    },
    input: {
      padding: 0, //9,
      border: 'none', //'1px solid silver',
      lineHeight: '32px',
      //backgroundColor:'#faf',
      borderColor: 'transparent',
      zIndex:2,
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5',

      },
    },
  },
}


const styleMentionsInputActive = {
  control: {
    padding: '4px 12px 4px 12px',
    border: 'none',
    overflow: 'auto',
    outline: 'none',
    boxShadow: 'none',
    resize: 'none',
    borderColor: theme.EgyptianBlue,
    lineHeight: '19px',
    minHeight: '40px',
  },

  '&multiLine': {
    control: {
      minHeight: 'unset',
    },
    highlighter: {

    },
    input: {
      padding: '4px 12px 4px 12px',
      border: 'none',
      overflow: 'auto',
      outline: 'none',
      boxShadow: 'none',
      resize: 'none',
      borderColor: theme.EgyptianBlue,
      lineHeight: '19px',
      minHeight: '40px',
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
}

const styleMention = {
  borderRadius:'4px',
  background: '#cee4e5',
}
